module.exports = __webpack_public_path__ + "img/DK32880002.6cd67691.png";